import React from 'react';
import { PropTypes } from 'prop-types';
import MyEditor from '../../../MyEditor';


const BasicParagraphPSWorld = ({
  title, handleInput, activeLanguage, languages, stateField,
}) => (
  <div className="w-full outline-none">
    <div className="bg-gray200 w-full py-1/2 flex relative p-4">
      <label className="flex font-americaMonoRegular flex flex-col text-xs  text-black pr-2 w-full mt-4" htmlFor="text">
        {title && <span className="uppercase">{title}</span>}
        {languages.map(lang => (
          <div className={`${activeLanguage.toLowerCase() === lang.toLowerCase() ? 'block' : 'hidden'} withinSlider font-americaMonoRegular bg-white outline-none w-full rounded-sm mt-1 ml-1 p-1 text-sm`} key={lang}>
            <MyEditor retrieveInput={handleInput} lang={lang} value={(stateField && stateField[lang.toLowerCase()]) || ''} classes="px-8 pt-4" />
          </div>
        ))}
      </label>
    </div>
  </div>
);

BasicParagraphPSWorld.propTypes = {
  title: PropTypes.string,
  handleInput: PropTypes.func.isRequired,
  activeLanguage: PropTypes.string,
  languages: PropTypes.arrayOf(PropTypes.string).isRequired,
  stateField: PropTypes.shape(),
};

BasicParagraphPSWorld.defaultProps = {
  title: '',
  activeLanguage: '',
  stateField: {
    en: '',
    es: '',
    ca: '',
    pt: '',
  },
};

export default BasicParagraphPSWorld;
